module.exports = __webpack_public_path__ + "img/payment-method.7e3c9e74.png";